<template>
  <v-container fluid class="admin-page">
      <v-row class="align-center" justify="space-around">
        <v-col
        cols="6"
        >
            <h2>Internal Stock Transfer</h2>
        </v-col>
        <v-col
        cols="6">
            <v-row>
                <v-col
                cols="5"
                >   
                    <v-text-field
                        label="Search Vendor ID"
                        append-icon="mdi-magnify"
                        solo
                        class="shrink"
                        clearable
                        dense
                        v-model="searchQuery"
                        @keydown.enter="searchVendor"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="2" class="fill-height">
                    <v-btn>
                        <v-icon>mdi-history</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="2" class="fill-height">
                    <v-btn
                        outlined
                        block
                        class="stock-export-btn text-capitalize"
                        :loading="exportLoading"
                        @click="exportStockExcel"
                    >
                        <v-icon left small>mdi-file-excel-outline</v-icon>
                        Export
                    </v-btn>
                </v-col>
                <v-col cols="3">
                    <router-link to="/dashboard/add/stock">
                        <v-btn class="text--futura text--white text-capitalize" dark block>
                            Add New Stock
                        </v-btn>
                    </router-link>
                </v-col>    
            </v-row>
        </v-col>
    </v-row>
    <v-row class="stock-filter-row" align="stretch">
        <v-col cols="12" md="4">
            <div class="stock-filter-card crystal-admin-form">
                <div class="stock-filter-heading">
                    <label class="stock-filter-label">Date Range</label>
                    <p class="stock-filter-caption">Filter transfer activity by period.</p>
                </div>
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="filterDate"
                    transition="scale-transition"
                    offset-y
                    content-class="compact-filter-calendar-menu"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="filterDateText"
                        label="Choose date range"
                        readonly
                        outlined
                        dense
                        class="stock-filter-field"
                        v-bind="attrs"
                        append-icon="mdi-calendar"
                        clearable
                        @click:clear="clearDateFilter"
                        hide-details
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filterDate"
                        no-title
                        scrollable
                        range
                        @change="updateDateQuery"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="saveDateFilter"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>  
        </v-col>
        <v-col cols="12" md="4">
            <div class="stock-filter-card crystal-admin-form">
                <div class="stock-filter-heading">
                    <label class="stock-filter-label">Route</label>
                    <p class="stock-filter-caption">Narrow transfers by source and destination.</p>
                </div>
                <v-row class="stock-route-grid">
                    <v-col cols="12" sm="6">
                        <v-select
                            label="From"
                            outlined
                            dense
                            hide-details
                            class="stock-filter-field"
                            :items="warehouses"
                            item-text="LocationName"
                            item-value="id"
                            clearable
                            v-model="filterFrom"
                            @change="updateFromQuery"
                            @click:clear="updateFromQuery('')"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            label="To"
                            outlined
                            dense
                            hide-details
                            class="stock-filter-field"
                            :items="warehouses"
                            item-text="LocationName"
                            item-value="id"
                            clearable
                            v-model="filterTo"
                            @change="updateToQuery"
                            @click:clear="updateToQuery('')"
                        />
                    </v-col>
                </v-row>
            </div>   
        </v-col>
        <v-col cols="12" md="4">
            <div class="stock-filter-card crystal-admin-form">
                <div class="stock-filter-heading">
                    <label class="stock-filter-label">Transfer Type</label>
                    <p class="stock-filter-caption">Focus on one stock movement category.</p>
                </div>
                <v-select
                    label="Type"
                    outlined
                    dense
                    hide-details
                    class="stock-filter-field"
                    :items="types"
                    item-text="text"
                    item-value="value"
                    v-model="filterType"
                    clearable
                    @change="updateTypeQuery"
                    @click:clear="updateTypeQuery('')"
                ></v-select>
            </div>       
        </v-col>
        <!-- <v-col cols="3">
            <div class="px-3 crystal-admin-form" height="100%">
                <label>Stock</label>    
                <v-row>
                    <v-col cols="5">
                        <v-text-field
                            placeholder="min"
                        />
                    </v-col>
                    <v-col cols="5">
                        <v-text-field
                            placeholder="max"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-col> -->
    </v-row>
    <v-row class="mt-2">
        <v-col
            cols="12"
        >
            <Alert />
            <v-data-table
                :headers="headers"
                :items="internalTransfers"
                :server-items-length="totalInternalTransfers"
                :options="pagination"
                @update:options="paginate"
                :footer-props="{
                    'items-per-page-options': listSize
                }"
                
                class="elevation-1"
            >
                <template v-slot:[`item.status`]="{ item }">
                    <v-switch
                        v-model="item.status"
                    ></v-switch>
                </template>
                <template v-slot:[`item.from_date`]="{ item }">
                    <td>{{ formatDate(item.from_date) }}</td>
                </template>
                <template v-slot:[`item.from`]="{ item }">
                    <td v-if="item.Vendor">{{ item.Vendor.company_name }}</td>
                    <td v-else-if="item.ShipFromLocation">{{ item.ShipFromLocation ? item.ShipFromLocation.LocationName : '' }}</td>
                </template>
                <template v-slot:[`item.qty`]="{ item }">
                    <span v-for="(product, index) in item.InternalTransferLines.slice(0, 3)" :key="product.id">
                        {{ product.Item ? product.Item.name : '' }}{{` (x${product.qty})` }}{{ index === 2 ? `...${item.InternalTransferLines.length - 3} more` : index === item.InternalTransferLines.length-1 ? '' : ',' }}
                    </span>
                </template>
                <template v-slot:[`item.destination`]="{ item }">
                    <td v-if="item.ToVendor">{{ item.ToVendor.company_name }}</td>
                    <td v-else-if="item.ShipToLocation">{{ item.ShipToLocation ? item.ShipToLocation.LocationName : '' }}</td>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                    {{ formatDate(item.createdAt) }}
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <td v-if="item.type == 'inter_warehouse'">Inter Warehouse</td>
                    <td v-else-if="item.type == 'adjustment'">Adjustment</td>
                    <td v-else-if="item.type == 'purchases'">Purchases</td>
                    <td v-else-if="item.type == 'purchase_return'">Purchase Return</td>
                </template>
                <template v-slot:[`item.memo`]="{ item }">
                    <td>{{ item.InternalTransferLines[0] ? item.InternalTransferLines[0].memo : 'Lorem Ipsum' }}</td>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small text class="mr-2" @click="getDetailInternalStock(item)">mdi-eye</v-icon>
                    <v-icon small text @click="showDeleteDialog(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
    <DeleteDialog 
        :message="`Remove Internal Stock ${internal_transfer.id} ?`"
        :item="internal_transfer"
        :showDelete="showDelete"
        @deleteItem="deleteStock"
        @closeDialog="closeDialog"
    />
    <DetailInternalStock
        :internal_stock="internal_transfer"
        :detail_internal_stock="detail_internal_stock"
        @closeDetail="closeDetail"
    />
  </v-container>
</template>

<script>
import * as XLSX from 'xlsx';
import Alert from '@/components/Alert.vue';
import DeleteDialog from '@/components/DeleteDialog.vue';
import server from '../api';
import DetailInternalStock from '@/components/DetailInternalStock.vue';

export default {
    name: 'Stock',
    components: {
        Alert,
        DeleteDialog,
        DetailInternalStock
    },
    data () {
        const filterDate = [];
        if (this.$route.query.start_date) filterDate.push(this.$route.query.start_date);
        if (this.$route.query.end_date) filterDate.push(this.$route.query.end_date);

        return {
            isSyncingRoute: false,
            suppressPaginateEvent: false,
            menu: false,
            headers: [
                { text: 'Date', value: 'from_date'},
                { text: 'From', value: 'from'},
                { text: 'Destination', value: 'destination'},
                { text: 'Type', value: 'type'},
                { text: 'Qty', value: 'qty'},
                { text: 'Memo', value: 'memo'},
                { text: 'Action', value: 'actions' }
            ],
            listSize: [15, 25, 50, 100, -1],
            pagination: {
                descending: !!this.$route.query.desc,
                itemsPerPage: +this.$route.query.per_page || +this.$session.get("stockItemPerPage") || 15,
                page: +this.$route.query.page || +this.$session.get("stockPage") || 1,
                totalItems: this.totalInternalTransfers,
            },
            internal_transfer: {},
            showDelete: false,
            exportLoading: false,
            types: [
                {
                    text: 'All',
                    value: ''
                },
                {
                    text: 'Adjustment',
                    value: 'adjustment'
                },
                {
                    text: 'Inter-Warehouse',
                    value: 'inter_warehouse'
                },
                {
                    text: 'Purchase Return',
                    value: 'purchase_return'
                },
                {
                    text: 'Purchases',
                    value: 'purchases'
                }
            ],
            filterType: this.$route.query.type || '',
            detail_internal_stock: false,
            filterDate,
            searchQuery: this.$route.query.vendor || "",
            filterTo: +this.$route.query.ship_to || "",
            filterFrom: +this.$route.query.ship_from || "",
        }
    },
    watch: {
        filterDate (val) {
            if (this.isSyncingRoute) return;
            this.updateDateQuery(val);
        },
        searchQuery (val) {
            if (this.isSyncingRoute) return;
            if (!val) {
                this.searchVendor();
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.syncFiltersFromRoute(to);
        this.fetchData(to);
        next();
    },
    methods: {
        serializeQueryParams (query = {}) {
            const params = new URLSearchParams();

            Object.keys(query).forEach((key) => {
                const value = query[key];
                if (value === undefined || value === null || value === '') return;
                params.append(key, value);
            });

            return params.toString();
        },
        getTransferFrom (item) {
            if (item.Vendor) return item.Vendor.company_name || '';
            if (item.ShipFromLocation) return item.ShipFromLocation.LocationName || '';
            return '';
        },
        getTransferDestination (item) {
            if (item.ToVendor) return item.ToVendor.company_name || '';
            if (item.ShipToLocation) return item.ShipToLocation.LocationName || '';
            return '';
        },
        getTransferTypeText (item) {
            if (item.type === 'inter_warehouse') return 'Inter Warehouse';
            if (item.type === 'adjustment') return 'Adjustment';
            if (item.type === 'purchases') return 'Purchases';
            if (item.type === 'purchase_return') return 'Purchase Return';
            return item.type || '';
        },
        getTransferItemsText (item) {
            if (!item.InternalTransferLines || !item.InternalTransferLines.length) return '';
            return item.InternalTransferLines.map((line) => {
                const itemName = line.Item ? line.Item.name : '';
                return `${itemName} - ${line.qty}`;
            }).join(', ');
        },
        getTransferMemo (item) {
            return item.InternalTransferLines && item.InternalTransferLines[0]
                ? item.InternalTransferLines[0].memo || ''
                : '';
        },
        normalizeInternalTransferPayload (payload) {
            if (payload && Array.isArray(payload.rows)) return payload.rows;
            if (Array.isArray(payload)) return payload;
            return [];
        },
        async fetchExportTransfers () {
            const baseQuery = { ...this.$route.query };
            const pageSize = +(baseQuery.per_page || this.pagination.itemsPerPage || 15);
            const totalRows = this.totalInternalTransfers || this.internalTransfers.length || 0;
            const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
            const rowsById = new Map();

            for (let page = 1; page <= totalPages; page += 1) {
                const queryString = this.serializeQueryParams({
                    ...baseQuery,
                    page,
                    per_page: pageSize,
                });
                const { data } = await server.get(`/internal_transfer?${queryString}`);
                const transfers = this.normalizeInternalTransferPayload(data.InternalTransfer);

                if (!transfers.length) break;

                transfers.forEach((item) => {
                    rowsById.set(item.id, item);
                });
            }

            return Array.from(rowsById.values());
        },
        downloadExcelFile (rows) {
            const sheetData = [
                ['id', 'date', 'from', 'destination', 'type', 'items', 'memo'],
                ...rows.map((row) => [
                    row.id,
                    row.date,
                    row.from,
                    row.destination,
                    row.type,
                    row.items,
                    row.memo,
                ]),
            ];
            const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
            const workbook = XLSX.utils.book_new();
            const stamp = this.formatDate(new Date(), 'YYYY-MM-DD');

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Transfers');
            XLSX.writeFile(workbook, `internal-stock-transfer-${stamp}.xlsx`);
        },
        async exportStockExcel () {
            this.exportLoading = true;

            try {
                const transfers = await this.fetchExportTransfers();

                if (!transfers.length) {
                    this.$store.commit('SET_ERROR', 'No stock transfer data available to export');
                    return;
                }

                const rows = transfers.map((item) => ({
                    id: item.id || '',
                    date: item.from_date ? this.formatDate(item.from_date, 'YYYY-MM-DD') : '',
                    from: this.getTransferFrom(item),
                    destination: this.getTransferDestination(item),
                    type: this.getTransferTypeText(item),
                    items: this.getTransferItemsText(item),
                    memo: this.getTransferMemo(item),
                }));

                this.downloadExcelFile(rows);
                this.$store.commit('SET_SUCCESS', `Exported ${rows.length} stock transfer rows`);
            } catch (err) {
                const message = err.response && err.response.data && err.response.data.errors
                    ? err.response.data.errors[0].message
                    : 'Failed to export stock transfer data';
                this.$store.commit('SET_ERROR', message);
            } finally {
                this.exportLoading = false;
            }
        },
        updateDateQuery (val = []) {
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            obj.start_date = val[0] ? val[0] : '';
            obj.end_date = val[1] ? val[1] : '';
            obj.page = 1;
            if (!obj.start_date) delete obj.start_date;
            if (!obj.end_date) delete obj.end_date;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: obj
            });
        },
        updateTypeQuery (val = '') {
            if (this.isSyncingRoute) return;
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            obj.type = val;
            obj.page = 1;
            if (!val) delete obj.type;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: obj
            });
        },
        updateFromQuery (val = '') {
            if (this.isSyncingRoute) return;
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            obj.ship_from = val;
            obj.page = 1;
            if (!val) delete obj.ship_from;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: obj
            });
        },
        updateToQuery (val = '') {
            if (this.isSyncingRoute) return;
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            obj.ship_to = val;
            obj.page = 1;
            if (!val) delete obj.ship_to;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: obj
            });
        },
        saveDateFilter () {
            if (this.$refs.menu) this.$refs.menu.save(this.filterDate);
            this.updateDateQuery(this.filterDate);
        },
        clearDateFilter () {
            this.filterDate = [];
            this.updateDateQuery([]);
        },
        syncFiltersFromRoute(route = this.$route) {
            const { query = {} } = route;
            const filterDate = [];

            if (query.start_date) filterDate.push(query.start_date);
            if (query.end_date) filterDate.push(query.end_date);

            this.isSyncingRoute = true;
            this.filterDate = filterDate;
            this.filterType = query.type || '';
            this.searchQuery = query.vendor || '';
            this.filterTo = query.ship_to ? +query.ship_to : '';
            this.filterFrom = query.ship_from ? +query.ship_from : '';
            const nextPagination = {
                ...this.pagination,
                descending: !!query.desc,
                itemsPerPage: +query.per_page || +this.$session.get("stockItemPerPage") || 15,
                page: +query.page || +this.$session.get("stockPage") || 1,
            };
            const paginationChanged =
                this.pagination.descending !== nextPagination.descending ||
                this.pagination.itemsPerPage !== nextPagination.itemsPerPage ||
                this.pagination.page !== nextPagination.page;

            if (paginationChanged) {
                this.suppressPaginateEvent = true;
                this.pagination = nextPagination;
            }
            this.$nextTick(() => {
                this.isSyncingRoute = false;
            });
        },
        fetchData(route = this.$route) {
            this.$store.dispatch('getInternalTransfer', route.query);
        },
        searchVendor () {
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            obj.vendor = this.searchQuery;
            obj.page = 1;
            if (this.searchQuery === '') delete obj.vendor;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: obj
            });
        },
        showDeleteDialog(item) {
            this.internal_transfer = item;
            this.showDelete = !this.showDelete;
        },
        closeDialog () {
            this.showDelete = !this.showDelete;
        },
        closeDetail () {
            this.detail_internal_stock = !this.detail_internal_stock;
        },
        deleteStock (id) {
            this.showDelete = !this.showDelete;
            server.delete(`/internal_transfer/${id}`, {
                headers: {
                    token: localStorage.token
                }
            })
                .then(result => {
                    this.fetchData(this.$route);
                    this.$store.commit('SET_SUCCESS', `Berhasil menghapus Internal Transfer ${result.data.InternalTransfer.id}`)
                })
                .catch(err => {
                    this.$store.commit('SET_ERROR', err.response.data.errors[0].message)
                });
        },
        getDetailInternalStock(item) {
            this.internal_transfer = item;
            this.detail_internal_stock = !this.detail_internal_stock;
        },
        paginate (val) {
            if (this.suppressPaginateEvent) {
                this.suppressPaginateEvent = false;
                return;
            }
            // emitted by the data-table when changing page, rows per page, or the sorted column/direction - will be also immediately emitted after the component was created
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            this.$session.set("stockPage", val.page);
            this.$session.set("stockItemPerPage", val.itemsPerPage);
            //console.log(this.$session.get("page"));
            if (val.itemsPerPage !== this.listSize[0]) obj.per_page = val.itemsPerPage;
            if (val.descending) obj.desc = 'true';
            else delete obj.desc;
            obj.orderby = val.sortBy;
            obj.page = val.page;
            obj.per_page = val.itemsPerPage;
            // check if old and new query are the same - VueRouter will not change the route if they are, so probably this is the first page loading
            let same = true;
            for (let key in query) {
                if (query[key] != obj[key]) {
                    same = false;
                    break;
                }
            }
            // to handle the case when a KEY exists in OBJ but not in query
            for (let key in obj) {
                if (query[key] != obj[key]) {
                    same = false;
                    break;
                }
            }
            if (same) this.fetchData(); // page has been manually reloaded in the browser
            else {
                this.$router.replace({
                    ...this.$router.currentRoute,
                    query: obj
                });
            }
        },
    },
    computed: {
        filterDateText: {
            get () {
                return this.filterDate.join(' - ');
            },
            set () {
                this.filterDate = [];
            }
        },
        internalTransfers () {
            return this.$store.state.internalTransfers;
        },
        totalInternalTransfers () {
            return this.$store.state.totalInternalTransfers;
        },
        warehouses () {
            return this.$store.state.warehouses;
        }
    },
    created () {
        this.syncFiltersFromRoute(this.$route)
        this.fetchData(this.$route)
        this.$store.dispatch('getWarehouses');
    }
}
</script>

<style>
.stock-filter-row {
  margin-top: 8px;
  margin-bottom: 8px;
}

.stock-export-btn {
  min-height: 48px;
  border-radius: 12px;
  border-color: rgba(26, 26, 26, 0.16) !important;
  color: #1f1f1f !important;
  letter-spacing: 0.02em;
}

.stock-filter-card {
  height: 100%;
  padding: 18px 20px 20px;
  border: 1px solid rgba(22, 22, 22, 0.08);
  border-radius: 18px;
  box-shadow: 0 14px 30px rgba(26, 26, 26, 0.06);
}

.stock-filter-heading {
  margin-bottom: 14px;
}

.stock-filter-label {
  display: block;
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.stock-filter-caption {
  margin: 6px 0 0;
  color: #707070;
  font-size: 13px;
  line-height: 1.4;
}

.stock-route-grid {
  margin: 0 -6px;
}

.stock-filter-field {
  margin-top: 0;
}

.stock-filter-card .v-input {
  font-size: 15px;
}

.stock-filter-card .v-input__slot {
  background: #fcfcfc !important;
}

.stock-filter-card .v-text-field--outlined > .v-input__control > .v-input__slot,
.stock-filter-card .v-select.v-text-field--outlined > .v-input__control > .v-input__slot {
  border-radius: 12px;
}

.stock-filter-card .v-label {
  color: #777 !important;
}

@media (max-width: 960px) {
  .stock-filter-card {
    padding: 16px;
  }
}
</style>
